import { cn } from '@/lib/cn'
import { Loader2 } from 'lucide-react'

type SpinnerVariant = 'ring' | 'dots' | 'gradient'

interface Props {
  size?: number
  className?: string
  variant?: SpinnerVariant
  label?: string
}

export function LoadingSpinner({ size = 16, className, variant = 'ring', label }: Props) {
  if (variant === 'dots') {
    return (
      <span
        role={label ? 'status' : undefined}
        aria-label={label}
        className={cn('inline-flex items-center gap-1', className)}
      >
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="h-1.5 w-1.5 animate-pulse rounded-full bg-current"
            style={{ animationDelay: `${i * 120}ms`, animationDuration: '800ms' }}
          />
        ))}
      </span>
    )
  }

  if (variant === 'gradient') {
    return (
      <span
        role={label ? 'status' : undefined}
        aria-label={label}
        className={cn(
          'inline-block shrink-0 animate-spin rounded-full bg-gradient-to-r from-muted via-muted-foreground to-foreground [mask:radial-gradient(circle_at_center,transparent_55%,#000_56%)]',
          className,
        )}
        style={{ width: size, height: size }}
      />
    )
  }

  // ring (default): Lucide Loader2
  return (
    <Loader2
      className={cn('shrink-0 animate-spin text-current', className)}
      size={size}
      role={label ? 'status' : undefined}
      aria-label={label}
    />
  )
}
